// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"83aceec4","732":"17b13d7a","977":"bd35e36e"}[chunkId] + ".chunk.js";
};